import React from 'react';
import { RadioGroupItem } from './radioGroup';
import { FormLabel } from './form';

interface RadioGroupItemWithLabelProps {
  value: string;
  id: string;
  label: string;
  className?: string;
}

export function RadioGroupItemWithLabel({ value, id, label, className }: RadioGroupItemWithLabelProps): JSX.Element {
  return (
    <div className='flex items-center gap-2'>
      <RadioGroupItem value={value} id={id} />
      <FormLabel htmlFor={id} className='cursor-pointer'>
        {label}
      </FormLabel>
    </div>
  );
}
